var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"home-container",class:{ 'dark-theme': _vm.isDark }},[_c('el-main',{staticClass:"main-content",staticStyle:{"padding":"0"}},[_c('router-view')],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }